export default __webpack_public_path__ + "static/media/Accelerons.08cc897b.jpeg";